/**
 * Polling types
 */
export const POLLING_TYPES = {
  EXTRACT: 'extract',
  RENDER: 'render',
  PROJECT: 'project',
};

/**
 * Project processing statuses
 */
export const PROJECT_PROCESSING_STATUSES = ['processing', 'pending'];

/**
 * Segment processing statuses
 */
export const SEGMENT_PROCESSING_STATUSES = ['extracting', 'rendering'];

/**
 * Project final statuses
 */
export const PROJECT_FINAL_STATUSES = ['completed', 'failed'];

/**
 * Segment extraction final statuses
 */
export const SEGMENT_FINAL_EXTRACT_STATUSES = ['extracted', 'failed_extraction'];

/**
 * Segment rendering final statuses
 */
export const SEGMENT_FINAL_RENDER_STATUSES = ['rendered', 'failed_rendering']; 